export const VALIDATE_INPUT = 'VALIDATE_INPUT'

export const registerValidation = name => ({
    type: VALIDATE_INPUT,
    payload: {
        name,
        valid: false
    }
})

export const validateInput = (name, valid) => ({
    type: VALIDATE_INPUT,
    payload: {
        name,
        valid
    }
})
